import { render, staticRenderFns } from "./InvoiceQ.vue?vue&type=template&id=4e728d6a&scoped=true"
import script from "./InvoiceQ.vue?vue&type=script&lang=js"
export * from "./InvoiceQ.vue?vue&type=script&lang=js"
import style0 from "./InvoiceQ.vue?vue&type=style&index=0&id=4e728d6a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e728d6a",
  null
  
)

export default component.exports